import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { User } from '@vendasta/iam';
import { CommentInterface, PostIdentifier, PostLatestCommentsInterface, TheLoopService } from '@vendasta/the-loop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sales-common-loop-v2-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentListComponent implements OnInit {
  @Input() initialComments: PostLatestCommentsInterface;
  @Input() postId = '';
  @Input() typeId = '';
  @Input() currentUser: User;
  @Input() iconSize = '40';

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onCommentAdded = new EventEmitter<PostIdentifier>();

  currentUserName = '';
  newCommentText = '';
  commenting = false;
  loadingMoreComments = false;
  comments: CommentInterface[] = [];
  hasMore = false;
  nextCursor = '';

  constructor(
    private readonly loopService: TheLoopService,
    private cdr: ChangeDetectorRef,
    private readonly alertService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.currentUserName = [this.currentUser.firstName, this.currentUser.lastName].join(' ');
    this.comments = (this.initialComments?.comments || []).reverse();
    this.hasMore = this.initialComments?.pagingMetadata?.hasMore;
    this.nextCursor = this.initialComments?.pagingMetadata?.nextCursor;
  }

  handleInput(event: any): void {
    if (!event.shiftKey && event.keyCode === 13) {
      this.comment();
    }
  }

  comment(): void {
    this.commenting = true;
    this.loopService
      .comment(this.typeId, this.postId, this.newCommentText)
      .pipe(
        take(1),
        finalize(() => {
          this.commenting = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe(
        (resp) => {
          this.comments.push(resp);
          this.newCommentText = '';
          this.onCommentAdded.emit(
            new PostIdentifier({
              typeId: this.typeId,
              postId: this.postId,
            }),
          );
          this.cdr.detectChanges();
        },
        (error) => {
          console.error(error);
          this.alertService.openErrorSnack('FRONTEND.LOOP.ERRORS.ERROR_COMMENTING');
        },
      );
  }

  loadMoreComments(): void {
    this.loadingMoreComments = true;
    this.loopService
      .listComments(this.typeId, this.postId, this.nextCursor, 10)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingMoreComments = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe(
        (resp) => {
          const comments: CommentInterface[] = (resp.comments || []).reverse();
          this.comments = comments.concat(this.comments);
          this.hasMore = resp.pagingMetadata.hasMore;
          this.nextCursor = resp.pagingMetadata.nextCursor;
          this.cdr.detectChanges();
        },
        (error) => {
          console.error(error);
          this.alertService.openErrorSnack('FRONTEND.LOOP.ERRORS.ERROR_LOADING_COMMENTS');
        },
      );
  }
}
